import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import {
  LoadingOutline,
  LeftOutline,
  RightOutline,
  DoubleLeftOutline,
  DoubleRightOutline,
  DownOutline,
  UpOutline,
  CalendarOutline,
  CloseCircleOutline,
  SearchOutline,
  CheckOutline,
  DeleteOutline,
  PlusOutline,
  CheckCircleOutline,
  CloseOutline,
  ExclamationCircleOutline,
  InfoCircleOutline
} from '@ant-design/icons-angular/icons';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { cacheInterceptor } from './interceptors/cache.interceptor';
import { LucideAngularModule } from 'lucide-angular';
import { LUCIDE_ICONS } from './shared/lucide-icons/lucide-icon-registry';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNzI18n(en_US),
    provideNzIcons([
      LoadingOutline,
      LeftOutline,
      RightOutline,
      DoubleLeftOutline,
      DoubleRightOutline,
      DownOutline,
      UpOutline,
      CalendarOutline,
      CloseCircleOutline,
      SearchOutline,
      CheckOutline,
      DeleteOutline,
      PlusOutline,
      CheckCircleOutline,
      CloseOutline,
      ExclamationCircleOutline,
      InfoCircleOutline
    ]),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    // provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([cacheInterceptor])),
    // provideClientHydration(withEventReplay()),
    importProvidersFrom(LucideAngularModule.pick(LUCIDE_ICONS)),
  ],
};
